export enum ContainerDataHooks {
  ROOT = 'AiAssistantWidgetContainer',
}
